<template>
<div id="report_container" >
    
    <iframe  v-if="proj" id="frame_report" src="" frameborder="0" style="border:0" allowfullscreen></iframe>
    <div class="empty-reports-txt text-left" v-if="proj == null">
      <h4 class="card-title">No Reports</h4>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
// import Vue from 'vue'
import $ from 'jQuery'

const MAX_WIDTH = 1200
const MAX_HEIGHT = 3550

export default {
  mounted: function () {
    if (this.proj == null) {
      return {}
    }
    $('#frame_report').attr('src', this.proj.url)
    this.resizeFrame(this.proj, MAX_WIDTH)
    const _this = this
    $(window).resize(function () {
      _this.resizeFrame(_this.proj, $(window).width())
    })
  },
  created: function () {},
  props: {},
  data: function () {
    return {title: 'Analytics'}
  },
  components: {},
  computed: {
    proj: function () {
      let p = this.$store.getters.organization._projects
      if (p == null) {
        return {}
      }
      return p
    }
  },
  methods: {
    resizeFrame: function (proj, newWidth) {
      const ratio = MAX_HEIGHT / MAX_WIDTH
      let width = (newWidth > MAX_WIDTH) ? MAX_WIDTH : newWidth
      let height = parseInt(width * ratio)

      if (proj.width && proj.height && proj.width < width) {
        width = parseInt(proj.width)
        height = parseInt(proj.height)
      } else if (proj.width && !proj.height && proj.width < width) {
        width = parseInt(proj.width)
        height = parseInt(width * ratio)
      } else if (!proj.width && proj.height) {
        width = parseInt(width)
        height = parseInt(proj.height)
      } else {
        width = '100%'
        height = MAX_HEIGHT
      }
      $('#frame_report').css('maxWidth', width + 'px')
      $('#frame_report').css('width', '100%')
      $('#frame_report').css('maxHeight', height + 'px')
      $('#frame_report').css('height', height + 'px')
    }
  }
}
</script>
<style>

#frame_report {
  background-color: #EEEEEE;
 }

#report_container {
  min-height: 100%;
  min-width: 100%;
}

.empty-reports-txt {
}
</style>



// WEBPACK FOOTER //
// Projects.vue?2f362df1